<template>

    <v-layout justify-center row wrap>

      <v-flex xs12>
        <v-card flat>

          <v-card-text class="pa-3">
            <v-layout row wrap>
              <v-flex xs12 text-right>
                Sucursales disponibles: <b>{{remainingBranches}}</b>
              </v-flex>
              <v-flex xs12 md5 class="mx-auto">
                <provider-title title="Añadir Sucursal"></provider-title>
                <template v-if="remainingBranches > 0">
                  <branch-office-form
                      ref="branchOfficeForm"
                      class="mt-3"
                      strict-mode
                      @change="branchOffice = $event"
                      @change:validation="isBranchOfficeValid = $event" />
                  <v-btn
                      :loading="saving"
                      :disabled="!isBranchOfficeValid"
                      @click="submit"
                      color="primary">Guardar</v-btn>
                </template>
                <template v-else>
                  <v-sheet class="text-center mt-4">
                    <div class="body-2">Haz alcanzado el límite de sucursales para tu plan</div>
                    ¿Necesitas agregar mas?
                    <br/>
                    <buy-new-plan-btn/>
                  </v-sheet>
                </template>
              </v-flex>

              <v-divider vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>

              <v-flex xs12 md5 class="mx-auto">
                <provider-title title="Sucursales"></provider-title>
                <card-listado
                    title="Sucursales"
                    color="cyan"
                    icon="fas fa-building"
                    :items="branches"
                    type="offices"
                    emptyMessage="No hay sucursales registradas"
                    ref="listadoOffices"
                    @saved="loadData"
                    @deleted="loadData"
                ></card-listado>
              </v-flex>

            </v-layout>

          </v-card-text>

        </v-card>
      </v-flex>
    </v-layout>

</template>
<script>
import { ApiUtils } from '@/utils/ApiUtils';
import BranchOfficeForm from "../../components/providers/panel/BranchOfficeForm";
import CardListado from '../../components/providers/panel/CardListado';

import {mapState, mapGetters} from 'vuex';
import BuyNewPlanBtn from "../../components/subscription/BuyNewPlanBtn";

export default {
  components: {
    BuyNewPlanBtn,
    WMainTitle: () => import('@/components/common/WMainTitle'),
    ProviderTitle: () => import('@/components/providers/panel/ProviderTitle'),
    CardListado,
    BranchOfficeForm
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Sucursales',
          disabled: true,
          href: ''
        }
      ],
      loading: false,
      saving: false,
      branchOffice: null,
      isBranchOfficeValid: false
    }
  },
  async mounted() {
    await this.loadData()
  },
  computed: {
    ...mapState(['currentProvider', 'currentBranchOffice']),
    ...mapGetters(['subscribedPlan', 'trialIsExpired', 'isOwner', 'isAdmin']),
    branches() {
      return this.$store.getters['branches/getAll']
    },
    remainingBranches(){
      const vm = this
      const branchesCount = vm.branches.length
      if(vm.trialIsExpired && !vm.subscribedPlan){
        return 1 - branchesCount
      }
      if(!vm.subscribedPlan) return 0
      return vm.subscribedPlan.max_branch_offices - branchesCount
    }
  },
  methods: {
    async loadData() {
      const vm = this
      vm.loading = true
      await this.$store.dispatch('branches/loadBranches')
      vm.loading = false
    },
    async submit() {
      const vm = this
      if(!vm.branchOffice) return
      const branchOffice = vm.branchOffice
      vm.saving = true
      const added = await this.$store.dispatch('branches/addNewBranch', branchOffice)
      vm.saving = false
      if (added)
        this.$refs.branchOfficeForm.reset()
        await ApiUtils.fetchMe()
    }
  }
}
</script>
